import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import VideoCommentsTable from '../../../../../../components/channel/[channelId]/video/content/VideoCommentsTable';
import { useApi } from 'hooks';
import { UseQueryResult } from '@tanstack/react-query';
import { components } from 'apis';
type Media = components['schemas']['Media'];
const VideoComments: React.FC = () => {
    const { api } = useApi();
    const { username, videoId } = useParams();
    if (username === undefined) {
        return <div>Channel Not Found</div>;
    }
    if (videoId === undefined) {
        return <div>Video Not Found</div>;
    }
    const metaDataQuery: UseQueryResult<Media> = api.useQuery(
        'get',
        '/media/{id}',
        { params: { path: { id: videoId } } },
        {
            refetchInterval: Infinity,
            refetchOnWindowFocus: false,
            refetchOnMount: false,
        },
    );
    return (
        <Stack sx={{ paddingTop: '40px' }}>
            <Typography variant="h5" gutterBottom component="div">
                {metaDataQuery.data?.title} Comments
            </Typography>
            <Box>
                <VideoCommentsTable videoId={videoId} />
            </Box>
        </Stack>
    );
};

export default VideoComments;
